<template>
  <div style="margin: auto; margin-top: 10px">
    <el-col :span="24" v-loading="alarmsLoading">
            <div style="width:100%; text-align:center;">
    <div
      id="plotly"
      ref="plotly"
      style="min-width:100%;max-width:100%"
    />
</div>
    </el-col>
    <el-col v-loading="alarmsLoading">
      <el-form :inline="true" label-position="top">
        <el-form-item label="." style="float: right">
          <el-button :disabled="!hasAnyChanges" @click="discardChanges()">{{
            $t("common.discard")
          }}</el-button>
        </el-form-item>
        <el-form-item label="." style="float: right">
          <el-button :disabled="!hasAnyChanges" @click="saveChanges()">{{
            $t("common.saveChanges")
          }}</el-button>
        </el-form-item>
        <el-form-item label="." style="float: right">
          <el-button @click="addFrequencyAlarm()">{{
            $t("alarms.addAlarm")
          }}</el-button>
        </el-form-item>
        <el-form-item style="float: left" :label="$t('alarms.axis')">
          <el-form-item>
            <el-select @change="updateChart()" v-model="axis">
              <el-option
                :label="$t('measurement.accelerometer_x')"
                value="accelerometer_x"
              />
              <el-option
                :label="$t('measurement.accelerometer_y')"
                value="accelerometer_y"
              />
              <el-option
                :label="$t('measurement.accelerometer_z')"
                value="accelerometer_z"
              />
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item
          style="float: left"
          slot=""
          :label="$t('home.measurements')"
        >
          <el-select
            clearable
            @change="measurementSelected"
            v-model="measurementId"
          >
            <el-option
              v-for="measurements in searchResult.measurements"
              v-bind:key="measurements.id"
              :value="measurements.id"
              :label="measurements.createdAt"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="24" v-loading="alarmsLoading">
      <el-row class="tableFlex">
        <el-table :data="alarms" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form
                label-width="100px"
                class="thresholdDirectionreverse"
                label-position="left"
              >
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('common.name')">
                      <el-input v-model="props.row.name" style="width: 50%" />
                    </el-form-item>
                    <el-form-item :label="$t('FrequencyPeakAnalyze.axis')">
                      <el-select
                        @change="axisUpdated(props.row.axis)"
                        v-model="props.row.axis"
                      >
                        <el-option
                          :label="$t('measurement.accelerometer_x')"
                          value="accelerometer_x"
                        />
                        <el-option
                          :label="$t('measurement.accelerometer_y')"
                          value="accelerometer_y"
                        />
                        <el-option
                          :label="$t('measurement.accelerometer_z')"
                          value="accelerometer_z"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('FrequencyPeakAnalyze.frequency')">
                      <el-input-number
                        @change="updateChart()"
                        v-model="props.row.frequency"
                      />
                    </el-form-item>
                    <el-form-item
                      :label="$t('FrequencyPeakAnalyze.sensitivity')"
                    >
                      <el-input-number
                        @change="checkAndupdateChart(props.$index,props.row.sensitivity)"
                        v-model="props.row.sensitivity"
                        label="2"
                        :min="2"
                        :step="2"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('dashboard.lastalarmscritical')"
                      class="label-inline"
                      style="
                        background-color: rgb(249, 20, 20, 0.7);
                        border-top-left-radius: 10px;
                        border-top-right-radius: 10px;
                      "
                    >
                      <el-input-number
                        v-model="props.row.threshold.critical"
                        @change="updateChart()"
                        :precision="4"
                        :step="0.01"
                        :min="props.row.threshold.hazard"
                        size="mini"
                      ></el-input-number>
                    </el-form-item>

                    <el-form-item
                      class="label-inline"
                      :label="$t('dashboard.lastalarmshazard')"
                      style="background-color: rgb(249, 147, 20, 0.7)"
                    >
                      <el-input-number
                        @change="updateChart(props)"
                        v-model="alarms[props.$index].threshold.hazard"
                        :precision="4"
                        :step="0.01"
                        :min="props.row.threshold.attention"
                        :max="props.row.threshold.critical"
                        size="mini"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      class="label-inline"
                      :label="$t('dashboard.lastalarmsattention')"
                      style="background-color: rgb(249, 210, 20, 0.7)"
                    >
                      <el-input-number
                        @change="updateChart()"
                        v-model="props.row.threshold.attention"
                        :precision="4"
                        :step="0.01"
                        :min="Number.MIN_SAFE_INTEGER"
                        :max="props.row.threshold.hazard"
                        size="mini"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.name')" prop="name">
            <template slot-scope="scope">
              <span style="margin-left: 10px"> {{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('FrequencyPeakAnalyze.axis')" prop="axis">
            <template slot-scope="scope">
              <span style="margin-left: 10px"> {{ scope.row.axis }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('FrequencyPeakAnalyze.frequency')"
            prop="frequency"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                {{ scope.row.frequency }} Hz</span
              >
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('FrequencyPeakAnalyze.sensitivity')"
            prop="sensitivity"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                ± {{ scope.row.sensitivity }} Hz</span
              >
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('alarms.level3')"
            prop="threshold.critical"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px"
                >{{ scope.row.threshold.critical }} G</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('alarms.level2')" prop="threshold.hazard">
            <template slot-scope="scope">
              <span style="margin-left: 10px"
                >{{ scope.row.threshold.hazard }} G</span
              >
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('alarms.level1')"
            prop="threshold.attention"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px"
                >{{ scope.row.threshold.attention }} G</span
              >
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('common.delete')"
            prop="threshold.attention"
          >
            <template slot-scope="scope">
              <el-button
                @click="deleteFrequencyAlarm(scope.$index)"
                type="danger"
                >{{ $t("common.delete") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import VibrationSignal from "../util/VibrationSignal";
import measurementService from "../service/measurement";
import cachios from "cachios";

var alarmTemplate = {
  name: "",
  axis: "accelerometer_x",
  frequency: 1000,
  sensitivity: 2,
  threshold: {
    attention: 0.1,
    hazard: 0.2,
    critical: 0.3,
  },
};
import Plotly from "./Plotly"

export default {
  name: "FreqAnalyzer",
  props: {
    pointId: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        name: "",
      },
      referenceMeasurement: "",
      referenceMeasurementDialog: false,
      alarms: [],
      hasAnyChanges: false,
      vibrationSignal: "",
      measurementId: "",
      axis: "accelerometer_x",
      series: [
        {
          x: [],
          y: [],
        },
      ],
      options: {
        displaylogo: false,
      },
      layout: {
        xaxis: {
          title: {
            text: `${this.$t("FrequencyPeakAnalyze.frequency")}`,
          },
        },
        yaxis: {
          title: {
            text: `${this.$t("FrequencyPeakAnalyze.amplitude")}`,
          },
        },
        height: 420,
        margin: {
          l: 50,
          r: 50,
          b: 50,
          t: 30,
          pad: 0,
        },
        displaylogo: false,
        // hovermode: "closest",
      },
    };
  },
  watch: {
    alarms: {
      // This will let Vue know to look inside the array
      deep: true,
      // We have to move our method to a handler field
      handler() {
        this.hasAnyChanges = true;
      },
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState("measurement", ["searchResult"]),
    ...mapState("frequencyPeakAlarm", ["alarmsLoading"]),
  },
  methods: {
    init() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      this.getMeasurements({
        dateRange: [start, end],
        tags: [],
        macAddress: "",
        measurementType: undefined,
        partial: undefined,
        error: undefined,
        upload: undefined,
        onlyMine: false,
        page: 1,
        pageSize: 10,
        paths: [],
        points: [this.pointId],
        favorite: false,
      });
      this.loadAlarms();
    },
    loadAlarms() {
      this.getAlarms({ pointId: this.pointId }).then((alarms) => {
        this.alarms = JSON.parse(JSON.stringify(alarms));
        setTimeout(() => (this.hasAnyChanges = false), 100);
        this.updateChart();
      });
    },
    saveChanges() {
      this.saveAlarms({ pointId: this.pointId, alarms: this.alarms })
        .then(() => {
          this.hasAnyChanges = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    discardChanges() {
      this.loadAlarms();
    },
    axisUpdated(axis) {
      this.axis = axis;
      this.updateChart();
    },
    measurementSelected() {
      measurementService.getMeasurement(this.measurementId).then((x) => {
        this.referenceMeasurement = x;
        this.updateChart();
      });
    },
    ...mapActions("measurement", ["getMeasurements"]),
    ...mapActions("frequencyPeakAlarm", ["saveAlarms", "getAlarms"]),
    deleteFrequencyAlarm(i) {
      this.alarms.splice(i, 1);
      this.updateChart();
    },
    deepClone(object) {
      return JSON.parse(JSON.stringify(object));
    },
    addFrequencyAlarm() {
      this.alarms.push(this.deepClone(alarmTemplate));
      this.updateChart();
    },
    checkAndupdateChart(index, sensitivity) {
      sensitivity = sensitivity - (sensitivity % 2);
      this.alarms[index].sensitivity = sensitivity;
      this.updateChart();
    },
    async updateChart() {
      let isReferenceMeasurementExists =
        this.measurementId &&
        this.referenceMeasurement &&
        this.referenceMeasurement.data;

      if (isReferenceMeasurementExists) {
        let signal = this.referenceMeasurement.data[this.axis];
        this.vibrationSignal = new VibrationSignal(
          signal.length,
          this.referenceMeasurement.calibratedSamplingRate,
          signal
        );
      } else {
        this.vibrationSignal = new VibrationSignal(12000, 12000);
      }
      var thresholdSeries = [];
      this.alarms
        .filter((x) => x.axis == this.axis)
        .forEach((alarm) => {
          this.vibrationSignal.addFrequency(
            alarm.frequency,
            alarm.threshold.critical * 0.9
          );

          let thresholdX = [
            alarm.frequency - alarm.sensitivity,
            alarm.frequency + alarm.sensitivity,
          ];
          thresholdSeries.push({
            x: thresholdX,
            y: [alarm.threshold.attention, alarm.threshold.attention],
            name: `${this.$t("alarms.level1")}`,
            showlegend: thresholdSeries.length < 3 ? true : false,
            mode: "lines+markers",
            line: {
              color: "rgb(249, 210, 20)",
              width: 5,
            },
            hoverinfo: "skip",
          });
          thresholdSeries.push({
            x: thresholdX,
            y: [alarm.threshold.hazard, alarm.threshold.hazard],
            name: `${this.$t("alarms.level2")}`,
            showlegend: thresholdSeries.length < 3 ? true : false,
            mode: "lines+markers",
            line: {
              color: "background-color: rgb(249, 147, 20, 1)",
              width: 5,
            },
            hoverinfo: "skip",
          });
          thresholdSeries.push({
            x: thresholdX,
            y: [alarm.threshold.critical, alarm.threshold.critical],
            name: `${this.$t("alarms.level3")}`,
            showlegend: thresholdSeries.length < 3 ? true : false,
            mode: "lines+markers",
            line: {
              color: "background-color: rgb(249, 20, 20, 1)",
              width: 5,
            },
            hoverinfo: "skip",
          });
        });

      let response = await cachios.post(
        `${process.env.VUE_APP_VIBRATION_APIURL}/signal/spectrum`,
        {
          half: true,
          dcOffset: true,
          window: "rectangular",
          mode: "accelerometer",
          signal: this.vibrationSignal.signal,
          samplingRate: this.vibrationSignal.samplingFrequency,
        }
      );

      this.series = [
        {
          x: response.data.results.x,
          y: response.data.results.y,
          name: `${this.$t("point.signal")}`,
          // hoverinfo: "skip",
        },
        ...thresholdSeries,
      ];
       Plotly.newPlot(this.$refs.plotly,
        this.series, this.layout, {
            displayModeBar: true,
            displaylogo: false,
            orientation:"v",
            doubleClick: "reset",
            responsive: true,
          });
        this.$refs.plotly.on('plotly_afterplot', function () {
        window.dispatchEvent(new Event('resize'));
      });
    },
  },
};
</script>

<style>
.el-form-item.label-inline {
  margin-bottom: 0px;
}
.label-inline .el-form-item__label {
  width: 100px;
  display: inline-block !important;
  padding: 0;
  margin: 0;
  padding-left: 10px;
  color: white;
  text-shadow: 1px 1px 1px black;
}
.label-inline .el-form-item__content {
  display: inline-block !important;
  margin-left: 10px;
}
.tableFlex {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 100% !important;
}
</style>